var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarouselNext = function SvgCarouselNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 29,
    fill: "none",
    viewBox: "0 0 18 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323338",
    fillRule: "evenodd",
    d: "m16.467 12.909-1.65 1.591 1.65 1.591c.91-.879.91-2.303 0-3.182M11.52 14.5.733 24.909a2.195 2.195 0 0 0 0 3.182c.91.879 2.387.879 3.297 0l12.437-12-1.65-1.591 1.65-1.591L4.03.909a2.39 2.39 0 0 0-3.297 0 2.195 2.195 0 0 0 0 3.182z",
    clipRule: "evenodd"
  })));
};
export default SvgCarouselNext;